import axios from "@/plugins/axios";

let url = (data) => "/api/console/mes/boms/${ecoNo}/${modelCode}/${revision}/${rank}/rows".interpolate(data);

export const rows = {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
};

export default rows;
